import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ComponentService } from '../../services/component/component.service';
import { ComponentInputBase } from '../../models/ComponentInputBase.model';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FunctionRegistryService } from '../../services/function-registry/function-registry.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-material',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: `
    @switch (getInput('materialType')) { @case ('button') {
    <button mat-button [color]="getInput('color')" (click)="executeFunction()">
      {{ getInput('text') }}
    </button>
    } @case ('icon-button') {
    <button
      mat-icon-button
      [color]="getInput('color')"
      (click)="executeFunction()"
    >
      <mat-icon>{{ getInput('icon') }}</mat-icon>
    </button>
    } @case ('raised-button') {
    <button
      mat-raised-button
      [color]="getInput('color')"
      (click)="executeFunction()"
    >
      {{ getInput('text') }}
    </button>
    } @case ('stroked-button') {
    <button
      mat-stroked-button
      [color]="getInput('color')"
      (click)="executeFunction()"
    >
      {{ getInput('text') }}
    </button>
    } @case ('flat-button') {
    <button
      mat-flat-button
      [color]="getInput('color')"
      (click)="executeFunction()"
    >
      {{ getInput('text') }}
    </button>
    } }
  `,
  styleUrl: './material.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialComponent
  extends ComponentInputBase
  implements OnInit, OnDestroy
{
  private destroy$ = new Subject<void>();
  private inputConfig: {
    [key: string]: {
      type: string;
      value: any;
      options?: string[];
      displayText?: string;
    };
  };
  private instanceId = Math.random().toString(36).substring(7);

  constructor(
    componentService: ComponentService,
    private functionRegistry: FunctionRegistryService
  ) {
    super(componentService);

    // Initialize inputConfig with all options at construction
    const functionNames = this.functionRegistry.getCurrentFunctionNames() || [];

    this.inputConfig = {
      materialType: {
        type: 'select',
        value: 'button',
        options: [
          'button',
          'icon-button',
          'raised-button',
          'stroked-button',
          'flat-button',
        ],
        displayText: 'Material component type',
      },
      text: {
        type: 'text',
        value: 'Button',
        displayText: 'Button text',
      },
      icon: {
        type: 'text',
        value: 'home',
        displayText: 'Icon',
      },
      color: {
        type: 'select',
        value: 'primary',
        options: ['primary', 'accent', 'warn'],
        displayText: 'Color',
      },
      clickFunction: {
        type: 'select',
        value: '',
        options: functionNames,
        displayText: 'Click Function',
      },
      clickFunctionParameters: {
        type: 'text',
        value: '',
        displayText: 'Parameters (comma separated)',
      },
    };

    // Set the initial inputs through the ComponentInputBase setter
    this.dynamicInput = this.inputConfig;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  executeFunction() {
    const functionName = this.getInput('clickFunction');
    if (functionName) {
      const paramString = this.getInput('clickFunctionParameters');
      // Convert string parameters to array, handling empty/null cases
      const parameters = paramString
        ? paramString.split(';').map((param: string) => param.trim())
        : [];

      this.functionRegistry.executeFunction(functionName, parameters);
    }
  }
}
